import * as React from 'react';
import * as Styles from '@material-ui/core/styles';
import * as Model from '../models'
import * as Colors from './Colors'
import { DialogTitle, Dialog, DialogContent, DialogActions, withStyles, Button, TextField, Checkbox, FormGroup, FormControlLabel } from '@material-ui/core';
import * as HokanApi from '../api/hokan'
import { parseApiResponse, PaginationState, DEFAULT_PAGINATION, DEFAULT_PAGE_SIZE } from '../types/pagination'
import { createDebouncedSearch } from '../util/SearchUtil'
import Pagination from './Pagination'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { ArrowForwardIos } from '@material-ui/icons';


const styles = () => Styles.createStyles({
    table: {
        marginBottom: "20px",
        color: Colors.primaryColor,
        fontSize: "0.9rem",
        transition: "linear 0.2s",
    },
    tableHead: {
        background: Colors.primaryColor,

    },
    row: {
        border: "solid",
        borderWidth: "1px",
        marginTop: "-1px",
        borderColor: Colors.borderColor,
        cursor: "pointer",
        '&:nth-of-type(odd)': {
            backgroundColor: Colors.backColor
        },
        "&:last-child": {


        },
        "&:hover": {
            backgroundColor: Colors.borderColorTransparent,
            outlineStyle: "solid",
            outlineWidth: "1px",
            outlineColor: Colors.primaryColor,
            border: "none",

        }
    },
    itemIcon: {
        "& svg": {
            fontSize: "15px"
        }
    },
    center: {
        textAlign: "center"
    },
    button: {
        border: "solid",
        borderWidth: "1px"
    },
    dialog: {
        padding: "10px"
    },
    searchField: {
        maxWidth: "200px"
    }
})


const CustomTableCell = withStyles(theme => ({
    head: {
        fontSize: "0.9rem",
        backgroundColor: Colors.primaryColor,
        color: Colors.white,
        "&:last-child": {

        },
        "&:first-child": {

        },
    },
    body: {
        fontSize: "0.9rem",
    }
}))(TableCell);


interface Props extends Styles.WithStyles<typeof styles> {
    open: boolean
    onSelect: (code: Model.ServiceCode) => void
    onCancel: () => void
    default13: boolean
    default63: boolean
    default93: boolean
    defaultTeiki: boolean
}

interface LocalState {
    dialogElement: JSX.Element
    codes: Model.ServiceCode[]
    searchText: string
    check13: boolean
    check63: boolean
    check93: boolean
    checkTeiki: boolean
    loading: boolean
    pagination: PaginationState
}

class ServiceCodeSelectDialog extends React.Component<Props, LocalState> {
    displayName = "ServiceCodeSelectDialog"
    constructor(props: Props) {
        super(props)
        this.state = {
            dialogElement: <div />,
            codes: [],
            searchText: "",
            check13: props.default13,
            check63: props.default63,
            check93: props.default93,
            checkTeiki: props.defaultTeiki,
            loading: false,
            pagination: DEFAULT_PAGINATION,
        }
    }

    private debouncedSearch = createDebouncedSearch(() => {
        this.loadWithCurrentFilters(1)
    })

    public componentDidMount = () => {
        this.loadWithCurrentFilters()
    }

    componentWillUnmount() {
        this.debouncedSearch.cancel()
    }

    // Build category filter params from current state
    private getCategoryParams(): { code_type?: string; teiki?: boolean } {
        const { check13, check63, check93, checkTeiki } = this.state
        // If teiki is selected, use teiki filter
        if (checkTeiki) return { teiki: true }
        // If a code_type is selected, use code_type filter
        if (check13) return { code_type: "13" }
        if (check63) return { code_type: "63" }
        if (check93) return { code_type: "93" }
        // No filter
        return {}
    }

    private loadWithCurrentFilters(page: number = 1) {
        this.setState({ loading: true })
        const categoryParams = this.getCategoryParams()
        const q = this.state.searchText.trim() || undefined
        HokanApi.getServiceCodes({ page, per_page: DEFAULT_PAGE_SIZE, q, ...categoryParams })
            .then(x => {
                const { data, pagination } = parseApiResponse(x.data as Model.ServiceCode[] | { data: Model.ServiceCode[]; pagination: any })
                this.setState({
                    codes: data,
                    pagination: {
                        page: pagination.page,
                        total: pagination.total,
                        totalPages: pagination.totalPages,
                        hasMore: pagination.hasMore,
                        perPage: pagination.perPage,
                    },
                    loading: false,
                })
            })
            .catch(err => {
                console.log(err)
                this.setState({ codes: [], pagination: DEFAULT_PAGINATION, loading: false })
            })
    }

    private goToPage = (page: number) => {
        if (page < 1 || page > this.state.pagination.totalPages) return
        this.loadWithCurrentFilters(page)
    }

    private onSearchChange = (value: string) => {
        this.setState({ searchText: value })
        this.debouncedSearch.trigger()
    }

    public close = () => {
        this.props.onCancel();
    }

    private selectCode(code: Model.ServiceCode) {
        this.props.onSelect(code);
    }

    private setCategory(check: string) {
        const checks = {
            check13: false,
            check63: false,
            check93: false,
            checkTeiki: false
        }
        if (check === "13") {
            checks.check13 = true;
        }
        else if (check === "63") {
            checks.check63 = true;
        }
        else if (check === "93") {
            checks.check93 = true;
        }
        else if (check === "teiki") {
            checks.checkTeiki = true;
        }
        // Update state then reload
        this.setState(checks, () => {
            this.loadWithCurrentFilters(1)
        })
    }

    public render() {
        const { classes } = this.props
        if (!this.props.open) return <div />

        return <Dialog
            className={classes.dialog}
            onClose={() => this.close()}
            fullWidth={true}
            maxWidth="md"
            open={true}>
            <DialogTitle>サービスコード選択</DialogTitle>
            <DialogContent>
                <FormGroup row style={{ marginBottom: "10px" }}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                value="13"
                                onChange={() => this.setCategory("13")}
                                checked={this.state.check13}
                                color="primary"
                            />
                        }
                        label="13:介護"
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                value="63"
                                checked={this.state.check63}
                                onChange={() => this.setCategory("63")}
                                color="primary"
                            />
                        }
                        label="63:予防"
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                value="定期"
                                onChange={() => this.setCategory("teiki")}
                                checked={this.state.checkTeiki}
                                color="primary"
                            />
                        }
                        label="定期"
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                value="93"
                                checked={this.state.check93}
                                onChange={() => this.setCategory("93")}
                                color="primary"
                            />
                        }
                        label="93:療養費"
                    />
                </FormGroup>
                <TextField
                    id="standard-search"
                    label="検索"
                    type="search"
                    value={this.state.searchText}
                    onChange={(e) => this.onSearchChange(e.target.value)}
                    className={classes.searchField}
                    margin="normal"
                    placeholder="名前・番号で検索"
                    fullWidth
                />
                <Table className={classes.table}>
                    <TableHead>
                        <TableRow>
                            <CustomTableCell style={{ textAlign: "left", padding: "1px" }}>番号</CustomTableCell>
                            <CustomTableCell style={{ textAlign: "center", padding: "1px" }}>名前</CustomTableCell>
                            <CustomTableCell align="right"></CustomTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {this.state.codes.map(code => (
                            <TableRow key={code.id} className={classes.row}
                                onClick={() => this.selectCode(code)}>
                                <CustomTableCell style={{ textAlign: "center", padding: "5px" }} component="th" scope="row">
                                    {code.code_type}{code.code_no}
                                </CustomTableCell>
                                <CustomTableCell style={{ textAlign: "left", padding: "5px" }} component="th" scope="row">
                                    {code.name}
                                </CustomTableCell>
                                <CustomTableCell align="right" className={classes.itemIcon}><ArrowForwardIos /></CustomTableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                {this.state.pagination.totalPages > 1 && (
                    <Pagination
                        pagination={this.state.pagination}
                        onPageChange={this.goToPage}
                    />
                )}
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" color="default" onClick={() => this.close()}>
                    戻る
                </Button>
            </DialogActions>
        </Dialog>
    }
}

export default Styles.withStyles(styles)(ServiceCodeSelectDialog)
